import { WizardStepHeader } from '../../wizard';
import { DebtMethodPicker } from '../DebtMethodPicker';
import pt from '../../../locales/pt';

export function DebtMethodStep({ value, onChange, impacts, loading }) {
  const copy = pt.liabilities.repaymentWizard.method;

  return (
    <div className="flex flex-col gap-3.5 pt-1.5">
      <WizardStepHeader
        eyebrow={copy.eyebrow}
        title={copy.title}
        subtitle={copy.subtitle}
      />
      {loading ? (
        <p className="text-sm text-muted-foreground">{pt.common.loading}</p>
      ) : (
        <DebtMethodPicker value={value} onChange={onChange} impacts={impacts} />
      )}
    </div>
  );
}

export default DebtMethodStep;
